import { render, staticRenderFns } from "./ModalPreviewVideo.vue?vue&type=template&id=506555ca&scoped=true"
import script from "./ModalPreviewVideo.vue?vue&type=script&lang=js"
export * from "./ModalPreviewVideo.vue?vue&type=script&lang=js"
import style0 from "./ModalPreviewVideo.vue?vue&type=style&index=0&id=506555ca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506555ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('506555ca')) {
      api.createRecord('506555ca', component.options)
    } else {
      api.reload('506555ca', component.options)
    }
    module.hot.accept("./ModalPreviewVideo.vue?vue&type=template&id=506555ca&scoped=true", function () {
      api.rerender('506555ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/entregadocumentos/ModalPreviewVideo.vue"
export default component.exports